/**
 * Application constants
 */

// Framer Motion variants
export const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
};

export const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

export const pulse = {
  scale: [1, 1.05, 1],
  transition: { repeat: Infinity, duration: 1.5 },
};

export const staggerChildren = {
  animate: { transition: { staggerChildren: 0.1 } },
};

export const slideInRight = {
  initial: { opacity: 0, x: 20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -20 },
};

// Transition presets
export const springTransition = {
  type: 'spring',
  stiffness: 300,
  damping: 30,
};

export const smoothTransition = {
  duration: 0.3,
  ease: 'easeInOut',
};

// Background carousel settings
export const BACKGROUND_TRANSITION_DURATION = 8000; // 8 seconds

// API retry settings
export const MAX_RETRIES = 3;
export const RETRY_DELAY = 1000; // 1 second

// Cache settings
export const IMAGE_CACHE_DURATION = 60 * 60 * 1000; // 1 hour

/** Pour les tests : forcer le mode destination (full = flyTo, light = carte pays + POIs).
 * Mettre 'full' ou 'light' pour forcer, null pour laisser la détection bande passante.
 */
export const FORCE_EXPERIENCE_MODE: 'full' | 'light' | null = 'full' ;
